import React from 'react';

const SvgJournal = props => (
  <svg
    id="journal_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>{'.journal_svg__cls-1{fill:#989898}'}</style>
    </defs>
    <path
      className="journal_svg__cls-1"
      d="M20.51 3.55a.7.7 0 00-.86-.49L12 5.19 4.35 3.06a.58.58 0 00-.19 0 .71.71 0 00-.7.71l.1 14.46a.71.71 0 00.51.67l7.73 2.22a.69.69 0 00.2 0 .58.58 0 00.19 0l7.74-2.22a.71.71 0 00.51-.67l.1-14.46a.68.68 0 00-.03-.22zm-9.22 15.93L5 17.66l-.08-13 6.41 1.79zM19 17.66l-6.33 1.81v-13l6.41-1.79zM12 21.12z"
    />
    <path
      className="journal_svg__cls-1"
      d="M14.39 10a.69.69 0 00.2 0l3-.86a.71.71 0 00-.39-1.36l-3 .86a.71.71 0 00.19 1.36zM17.25 11l-3 .87a.7.7 0 00-.51.67.7.7 0 00.7.71.69.69 0 00.2 0l3-.86a.71.71 0 00-.39-1.39zM14.39 16.56a.68.68 0 00.2 0l3-.87a.7.7 0 00.48-.87.71.71 0 00-.87-.48l-3 .86a.71.71 0 00-.52.68.7.7 0 00.71.68z"
    />
  </svg>
);

export default SvgJournal;
